import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "App-Bidd-Pay-Modal-H" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { primary: "" }
const _hoisted_5 = { "txt-center": "" }
const _hoisted_6 = {
  key: 2,
  "txt-center": "",
  class: "App-Bidd-Pay-Modal-Err"
}
const _hoisted_7 = { key: 3 }
const _hoisted_8 = {
  key: 0,
  "txt-center": "",
  class: "App-Bidd-Pay-Modal-Err"
}
const _hoisted_9 = {
  key: 1,
  "txt-center": "",
  class: "App-Bidd-Pay-Modal-Succ"
}
const _hoisted_10 = {
  "txt-center": "",
  class: "dialog-footer"
}
const _hoisted_11 = {
  key: 0,
  style: {"padding-left":"14px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_appBiddingProfileModal = _resolveComponent("appBiddingProfileModal")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_StripeElement = _resolveComponent("StripeElement")!
  const _component_circle_check_filled = _resolveComponent("circle-check-filled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": _ctx.isOpen,
    title: "Paying For Talent",
    width: "500px",
    "before-close": _ctx.handleClose,
    "custom-class": "App-Bidd-Pay-Modal App-Unpadded",
    center: "",
    "destroy-on-close": true
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_10, [
        (!_ctx.hasPaid)
          ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              onClick: _ctx.submitPayment,
              disabled: _ctx.loading,
              type: "primary",
              size: "large",
              "is-block": ""
            }, {
              default: _withCtx(() => [
                _cache[6] || (_cache[6] = _createTextVNode(" Pay ", -1)),
                (_ctx.talentPrice)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.talentPrice.symbol) + " " + _toDisplayString(_ctx.$filters.number(_ctx.talentPrice.amount)), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["onClick", "disabled"])), [
              [_directive_loading, !_ctx.talentPrice || _ctx.loading]
            ])
          : _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              "is-all-borderless": "",
              plain: "",
              onClick: _ctx.visitTalent,
              disabled: _ctx.loading,
              type: "primary",
              size: "large",
              "is-block": ""
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode(" Visit Talent's Profile ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick", "disabled"])), [
              [_directive_loading, !_ctx.talentPrice || _ctx.loading]
            ])
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        (_ctx.cardElement !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_appBiddingProfileModal, {
                opportunity: _ctx.opportunity,
                talent: _ctx.talent
              }, null, 8, ["opportunity", "talent"]),
              _createElementVNode("div", _hoisted_2, [
                (_ctx.talentPrice)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_el_divider),
                      _createVNode(_component_el_descriptions, {
                        class: "App-Pricing-Break",
                        title: "Pricing Breakdown",
                        column: 1,
                        size: "small",
                        direction: "horizontal",
                        border: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_descriptions_item, { label: "Amount Before Tax:" }, {
                            default: _withCtx(() => [
                              _createElementVNode("b", null, "$ " + _toDisplayString(_ctx.$filters.number(_ctx.talentPrice.amountBeforeTax)), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_descriptions_item, { label: "Tax:" }, {
                            default: _withCtx(() => [
                              _createElementVNode("b", null, _toDisplayString(_ctx.talentPrice.tax) + "%", 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_divider),
                          _createVNode(_component_el_descriptions_item, { label: "Total Amount:" }, {
                            default: _withCtx(() => [
                              _createElementVNode("b", _hoisted_4, "$ " + _toDisplayString(_ctx.$filters.number(_ctx.talentPrice.amount)), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_divider),
                _createElementVNode("p", _hoisted_5, [
                  _cache[1] || (_cache[1] = _createTextVNode(" Secure Payments ", -1)),
                  _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                  _cache[3] || (_cache[3] = _createTextVNode(" Powered by ", -1)),
                  _createVNode(_component_el_link, {
                    href: "https://stripe.com/",
                    target: "__blank",
                    type: "primary"
                  }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createTextVNode(" Stripe Inc ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                (!_ctx.result.paymentIntent)
                  ? (_openBlock(), _createBlock(_component_StripeElement, {
                      key: 1,
                      class: "App-Stripe-Ele",
                      element: _ctx.cardElement,
                      onChange: _ctx.changedStripeCard
                    }, null, 8, ["element", "onChange"]))
                  : _createCommentVNode("", true),
                (_ctx.event && _ctx.event.error)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.event.error.message), 1))
                  : _createCommentVNode("", true),
                (_ctx.result)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                      (_ctx.result.error)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.result.error.message), 1))
                        : (_ctx.result.paymentIntent !== undefined)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                              _createVNode(_component_el_icon, { style: {"font-size":"40px"} }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_circle_check_filled)
                                ]),
                                _: 1
                              }),
                              _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                              _cache[5] || (_cache[5] = _createElementVNode("span", null, " Payment Successful ", -1))
                            ]))
                          : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_divider)
              ])
            ]))
          : _createCommentVNode("", true)
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 1
  }, 8, ["model-value", "before-close"]))
}